import { AxiosError } from 'axios';
import { GET_MIMS_AUTH_URL } from '../../constants/apiUrls';
import { GET_MIMS_AUTH_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: string) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetMIMSAuth = ({ onSuccess, onError }: Input) => {
  const getMIMSAuth = async () => {
    const res = await axiosClient.get<string>(GET_MIMS_AUTH_URL);

    return res.data;
  };

  return useCustomQuery(
    GET_MIMS_AUTH_KEY,
    getMIMSAuth,
    {
      enabled: false,
      onSuccess,
      onError,
    },
    false
  );
};
